module.exports = __webpack_public_path__ + "static/star_background-799f8780bcdd19811b8925bbe9a1f930.png";